/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import ReactDOM from "react-dom";
import { ReactNode } from "react";
import { Modal, ModalProps } from "@itwin/itwinui-react";
import { Provider } from "react-redux";
import { store } from "store/reduxStore";
import "./Modal.scss";

const PORTALID = "sandbox-portal-container";

export type ModalManagerProps = Omit<ModalProps, "title" | "children" | "isOpen">;

export class ModalManager {
  private static _portalContainer: HTMLElement;
  private static _modal: ReactNode;

  private static get portalContainer() {
    if (!ModalManager._portalContainer) {
      let portalContainer = document.getElementById(PORTALID);
      if (!portalContainer) {
        portalContainer = document.createElement("div");
        portalContainer.setAttribute("id", PORTALID);
        document.body.appendChild(portalContainer);
      }
      ModalManager._portalContainer = portalContainer;
    }
    return ModalManager._portalContainer;
  }

  public static createModal(title: string, node: ReactNode, modelProps?: ModalManagerProps) {
    ModalManager._modal = <Modal {...modelProps} className={`sandbox-modal ${modelProps?.className ? modelProps?.className : ""}`.trim()} title={title} isOpen={true}>{node}</Modal>;
    ModalManager.updateModal();
  }

  public static closeModal() {
    ModalManager._modal = undefined;
    ModalManager.updateModal();
  }

  private static updateModal() {
    ReactDOM.render(<Provider store={store}>{ModalManager._modal}</Provider>, ModalManager.portalContainer);
  }
}
